import { render, staticRenderFns } from "./VenE_AddressList.vue?vue&type=template&id=7c80d1ed"
import script from "./VenE_AddressList.vue?vue&type=script&lang=js"
export * from "./VenE_AddressList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports